import React, { useEffect } from 'react'
import '../../assets/theme/theme.less'
import { LayoutComponent as Layout, ButtonComponent as Button } from '../../components'
import { Row, Col } from 'antd'
import ProductsTable from './productsTable'
import { useDispatch, useSelector } from 'react-redux'
import { getProducts } from '../../redux/slices/productsSlice'
import { useNavigate } from 'react-router-dom'
import { ReactComponent as iconPlus } from '../../assets/img/plus.svg'

const Products = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const { isLoading, products } = useSelector(state => state.products)

    useEffect(() => {
        dispatch(getProducts())
    }, [dispatch])

    const handleEdit = (productId) => {
        navigate(`/produtos/${productId}`)
    }

    const handleManageFiles = (productId) => {
        navigate(`/produtos/${productId}`)
    }

    const handleCreate = () => {
        navigate('/produtos/novo')
    }

    return (
        <Layout width>
            <Row>
                <Col md={24}>
                    <div className="d-flex justify-between align-center">
                        <h1 className="title page-title">Produtos</h1>
                        <Button type="primary" icon={iconPlus} onClick={handleCreate}>
                            Novo Produto
                        </Button>
                    </div>
                </Col>
                <Col md={24} className="mt-25">
                    <ProductsTable 
                        loading={isLoading} 
                        products={products} 
                        onEdit={handleEdit}
                        onManageFiles={handleManageFiles}
                    />
                </Col>
            </Row>
        </Layout>
    )
}

export default Products
